/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetProjectMetricsSummaryPayload,
  GetProjectMetricsSummaryPayload$Outbound,
  GetProjectMetricsSummaryPayload$outboundSchema,
} from "../components/getprojectmetricssummarypayload.js";

export type GetProjectOverviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetProjectOverviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetProjectOverviewSecurity = {
  option1?: GetProjectOverviewSecurityOption1 | undefined;
  option2?: GetProjectOverviewSecurityOption2 | undefined;
};

export type GetProjectOverviewRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload;
};

/** @internal */
export type GetProjectOverviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetProjectOverviewSecurityOption1$outboundSchema: z.ZodMiniType<
  GetProjectOverviewSecurityOption1$Outbound,
  GetProjectOverviewSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getProjectOverviewSecurityOption1ToJSON(
  getProjectOverviewSecurityOption1: GetProjectOverviewSecurityOption1,
): string {
  return JSON.stringify(
    GetProjectOverviewSecurityOption1$outboundSchema.parse(
      getProjectOverviewSecurityOption1,
    ),
  );
}

/** @internal */
export type GetProjectOverviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetProjectOverviewSecurityOption2$outboundSchema: z.ZodMiniType<
  GetProjectOverviewSecurityOption2$Outbound,
  GetProjectOverviewSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getProjectOverviewSecurityOption2ToJSON(
  getProjectOverviewSecurityOption2: GetProjectOverviewSecurityOption2,
): string {
  return JSON.stringify(
    GetProjectOverviewSecurityOption2$outboundSchema.parse(
      getProjectOverviewSecurityOption2,
    ),
  );
}

/** @internal */
export type GetProjectOverviewSecurity$Outbound = {
  Option1?: GetProjectOverviewSecurityOption1$Outbound | undefined;
  Option2?: GetProjectOverviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetProjectOverviewSecurity$outboundSchema: z.ZodMiniType<
  GetProjectOverviewSecurity$Outbound,
  GetProjectOverviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetProjectOverviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetProjectOverviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getProjectOverviewSecurityToJSON(
  getProjectOverviewSecurity: GetProjectOverviewSecurity,
): string {
  return JSON.stringify(
    GetProjectOverviewSecurity$outboundSchema.parse(getProjectOverviewSecurity),
  );
}

/** @internal */
export type GetProjectOverviewRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload$Outbound;
};

/** @internal */
export const GetProjectOverviewRequest$outboundSchema: z.ZodMiniType<
  GetProjectOverviewRequest$Outbound,
  GetProjectOverviewRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getProjectMetricsSummaryPayload:
      GetProjectMetricsSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getProjectMetricsSummaryPayload: "GetProjectMetricsSummaryPayload",
    });
  }),
);

export function getProjectOverviewRequestToJSON(
  getProjectOverviewRequest: GetProjectOverviewRequest,
): string {
  return JSON.stringify(
    GetProjectOverviewRequest$outboundSchema.parse(getProjectOverviewRequest),
  );
}
